import { useNavigate } from 'react-router';
import { ROUTES } from '../../../../constants/routes';
import { useCreateModalStore } from '../../../../stores/createModalStore';
import { CollectionCreateForm } from '../collection/CollectionCreateForm';
import type { CreateBodyProps } from './createBodyProps';

/**
 * New collection. On success it opens the collection, unless the entry point
 * asked to stay put (the canvas, which shows the new folder in place).
 */
export function CollectionBody({
  destination,
  onDone,
  onChangeDestination,
  onBusyChange,
}: CreateBodyProps) {
  const navigate = useNavigate();
  const onCollectionCreated = useCreateModalStore((s) => s.request?.onCollectionCreated);
  return (
    <CollectionCreateForm
      parent={destination}
      onChangeParent={onChangeDestination}
      onBusyChange={onBusyChange}
      onUseExisting={(c) => {
        onDone();
        navigate(ROUTES.collection(c.id));
      }}
      onCreated={(c) => {
        onDone();
        if (onCollectionCreated) onCollectionCreated(c);
        else navigate(ROUTES.collection(c.id));
      }}
    />
  );
}
